export const linkify = (text: string, linkColor: string, maxLength: number = 30) => {
  if (!text) return "";

  text = text
    .replace(/<p>/gi, "")
    .replace(/<\/p>/gi, "<br>")
    .replace(/<br\s*\/?>/gi, "<br>");

  text = text.replace(/<(?!br\s*\/?)[^>]+>/gi, "");

  const urlRegex = /(https?:\/\/[^\s<]+)/g;

  return text.replace(urlRegex, (fullUrl: string) => {
    const displayUrl =
      fullUrl.length > maxLength
        ? fullUrl.substring(0, maxLength) + "..."
        : fullUrl;

    return `<a href="${fullUrl}" target="_blank" rel="noopener noreferrer" style="color:${linkColor}; text-decoration:underline;">${displayUrl}</a>`;
  });
};
